import axiosClient from './axiosClient';
import { AuthUser } from './auth.api';

// Reusing your existing User interface, adding creation timestamp for admin audits
export interface AdminUserRecord extends AuthUser {
  createdAt?: string;
  role: 'admin' | 'user';
  isActive: boolean;
}

export const fetchAllUsersList = async (): Promise<AdminUserRecord[]> => {
  const res = await axiosClient.get<AdminUserRecord[]>('/users');
  return res.data;
};

export const toggleUserStatus = async (
  userId: string,
  shouldActivate: boolean
): Promise<AdminUserRecord> => {
  const response = await axiosClient.patch(`/users/${userId}/status`, {
    isActive: shouldActivate
  });
  return response.data;
};
